module.exports = __webpack_public_path__ + "img/acordo.356fcfdf.svg";